<template lang="pug">
    .container
        .title-container
            .title-group
                p.step 
                    strong STEP 04: 
                    | Accommodation Details
                h3 When do you need accommodation?

            .button-wrap
                router-link.button(to="/meal") Skip this step               

        form 
            .input-group.date-group
                label(for="from") Dates

                .with-button
                    .datepicker-trigger
                        input(
                            type="text" 
                            id="datepicker-trigger"
                            class="datepicker-input" 
                            placeholder="Select the dates" 
                            :value="formatDates(dateOne, dateTwo)"
                            autocomplete="off"
                            )

                        AirbnbStyleDatepicker(
                            :trigger-element-id="'datepicker-trigger'" 
                            :mode="'range'"
                            :fullscreen-mobile="true"
                            :minDate="minDate"
                            :date-one="dateOne"
                            :date-two="dateTwo"
                            :trigger="trigger"
                            @date-one-selected="val => { dateOne = val }"
                            @date-two-selected="val => { dateTwo = val }"
                            )                    

                    button(type="submit" class="button btn-black" @click.prevent="showRooms") Show available rooms

            p(v-if="error" style="margin: 0; color: rgb(255, 0, 0)") {{ error }}

        .divider(v-if="!availableRooms.length")

        .rooms-container(v-if="availableRooms.length")
            .title-container 
                h3 Available rooms

                .appendix-wrap
                    span(data-toggle="tooltip" title="Bread & Breakfast") BB - Bread & Breakfast
                    span(data-toggle="tooltip" title="Half Board") HB - Half Board
                    span(data-toggle="tooltip" title="Full Board") FB - Full Board

            room(v-for="room in availableRooms" :room="room" :startDate="dateOne" :endDate="dateTwo" :key="room.id" @pickedRoom="pickedRoom" @pickedRoomData="pickedRoomData" @clickedRoom="clickedRoom")


        .button-row
            a.back(href="" @click.prevent="$router.go(-1)") 
                i.fa.fa-angle-left
                | Back

            a.next(href="" :class="{ active: isChecked }" @click.prevent="saveSecondStep") Proceed

        //- popup slider
        roomslider(:selectedRoom="selectedRoom" ref="roomSliderPopup")             

</template>

<script>
    import Vue from 'vue';
    import format from 'date-fns/format';
    import room from './Room';
    import roomslider from './RoomSlider';    
    import moment from 'moment';
    // import $ from 'jquery';
    import { mapGetters, mapActions } from 'vuex';  

    export default {
        name: 'Accommodation',
        data() {
            return {
                dateFormat: 'D/MM/YYYY',
                dateOne: '',
                dateTwo: '',
                minDate: '',
                availableRooms: {},
                pendingRooms: {},
                isChecked: false,
                selectedRoomData: [],
                validateCount: 0,
                trigger: false,
                error: ''
            }            
        },
        components: {
            room,
            roomslider
        },
        computed: mapGetters(['allRooms', 'firstStepBooking', 'secondStepBooking', 'selectedRoom']),
        methods: {
            ...mapActions(['fetchRooms', 'fetchRoom', 'postFirstStepBooking', 'postSecondStepBooking', 'addToTotal']),
            formatDates(dateOne, dateTwo) {
                let formattedDates = '';

                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }

                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }

                return formattedDates
            },
            clickedRoom(selectedRoom) {
                if(selectedRoom) {
                    // console.log(selectedRoom.room_id);
                    this.fetchRoom(selectedRoom.room_id).then(result => {
                        this.$refs.roomSliderPopup.toggle();
                    });
                }
            },            
            showRooms() {

                if(this.dateOne == '' || this.dateTwo == '') {
                    this.error = 'Please select the valid start/end dates!';
                } else {
                    this.error = '';
                }                

                if(this.dateOne == '' && this.dateTwo == '') {
                    this.trigger = !this.trigger
                }

                var dates = { 'start_date': this.dateOne, 'end_date': this.dateTwo };

                this.fetchRooms(dates).then(result => {
                    this.availableRooms = this.allRooms.results.availableRooms;
                    // this.pendingRooms = this.allRooms.results.unconfirmedRooms;

                    this.$nextTick(function () {
                        $('[data-toggle="tooltip"]').tooltip()
                    });

                });
            },
            pickedRoom(selectedRoom) {
                if(selectedRoom) {
                    selectedRoom.forEach(m => {
                        if(m.checked == true) {
                            this.isChecked = m.validate;

                            var item = this.selectedRoomData.find(n => n.room_id === m.room_id);
                            if(item) { return Object.assign(item, m); }
                            this.selectedRoomData.push(m);
                        } else {
                            this.removeItem(this.selectedRoomData, 'room_id', m.room_id);                            
                        }
                    });
                }                
            },
            pickedRoomData(selectedRoom) {
                if(selectedRoom) {
                    selectedRoom.forEach(m => {
                        this.isChecked = m.validate;
                        var item = this.selectedRoomData.find(n => n.room_id === m.room_id);
                        if(item) { return Object.assign(item, m); }
                        this.selectedRoomData.push(m);
                    });
                }                
            },
            removeItem(array, element, item){
                for(var i in array){
                    if(array[i][element] == item){
                        array.splice(i,1);
                        break;
                    }
                }
            },
            createdBookingId() {
                var booking_id;

                if (window.localStorage.getItem("firstStepBookingId") === null) {
                    this.postFirstStepBooking({ 'event_category_id': this.$route.params.id }).then(result => {
                        booking_id = window.localStorage.setItem("firstStepBookingId", this.firstStepBooking.results.id);
                    });                   
                } else {
                    booking_id = window.localStorage.getItem("firstStepBookingId"); 
                }                
            },           
            saveSecondStep() {

                var start_date = moment(String(this.dateOne), 'YYYY-MM-DD');
                var end_date = moment(String(this.dateTwo), 'YYYY-MM-DD');

                var diff = end_date.diff(start_date, 'days');
                
                var total = 0;

                this.selectedRoomData.forEach(data => {
                    total += data.total_only_room_cost * parseInt(diff); 
                    total += data.total_bb_cost * parseInt(diff);
                    total += data.total_hb_cost * parseInt(diff);
                    total += data.total_fb_cost * parseInt(diff);
                });                

                for(var i in this.selectedRoomData) {
                    delete this.selectedRoomData[i].checked;
                    delete this.selectedRoomData[i].validate;
                    delete this.selectedRoomData[i].total_only_room_cost;
                    delete this.selectedRoomData[i].total_bb_cost;
                    delete this.selectedRoomData[i].total_hb_cost;
                    delete this.selectedRoomData[i].total_fb_cost;
                }             

                var bookingData = {
                    "booking_id": parseInt(window.localStorage.getItem("firstStepBookingId")),
                    "start_date": this.dateOne,
                    "end_date": this.dateTwo,
                    "rooms": this.selectedRoomData 
                };

                var totalData = {
                    "type": 'accommodation',
                    "total": total
                }
                
                //add to main total
                this.addToTotal(totalData);

                //console.log(bookingData);

                this.postSecondStepBooking(bookingData).then(() => {
                    this.$router.push('/meal');
                });

            }                   
        },
        mounted() {
            this.minDate = moment().add(1, "days").format("YYYY-MM-DD");

            this.$watch('roomOnlySpinner.val', () => {
                this.pickedRoomData();
            });

            this.createdBookingId();
        }
    };
</script>

<style lang="sass" scoped>
    @import "@/assets/css/2-base/_variables.sass"

    .divider
        height: 400px

    .rooms-container
        .title-container
            margin: 30px 0

            h3
                font:
                    size: 24px
                    weight: 400

            span 
                display: inline-block
                font:
                    size: 15px
                color: #A6653E
                margin-right: 20px

                &:last-of-type
                    margin-right: 0

        @media (max-width: $device-sm)
            .title-container
                h3 
                    margin-bottom: 15px

    @media (max-width: $device-sm)
        form
            .input-group
                &.date-group
                    .with-button
                        flex-direction: column

                        .datepicker-trigger
                            .datepicker-input
                                max-width: 450px
                                width: 100%
                                margin-bottom: 10px

                        .button 
                            width: 200px
</style>

